import { initJSBridge } from './jsBridge';
import { sensorsLogin, registerPage } from '../sensors/sensorsUtil';
import { parseRoute } from '../index';

const ua = window.navigator.userAgent;
const WEBVIEW_CAPABILITY_TIMEOUT = 800;
const XLM_VERSION_ORIGIN_KEY = 'xlm-version-origin';

/* 鑫联盟webview是否加载完成 */
let isReady = false;

/* 鑫联盟webview加载完成的回调函数 */
let initCallback = null;

initJSBridge();

function checkUserAgent(userAgent) {
  // 1. 明确是鑫联盟，直接 true
  if (/Suixingpay-Xlm/i.test(userAgent)) {
    return true;
  }
  // 2. 明确是其他已知 App，直接 false
  if (/Suixingpay-(Syt|JY)/i.test(userAgent)) {
    return false;
  }
  if (/SuiXingPay-Mpos/i.test(userAgent)) {
    return false;
  }
  // 3. 明确是常见浏览器 / 外部容器，直接 false
  if (/Safari/i.test(userAgent) || /MicroMessenger/i.test(userAgent)) {
    return false;
  }
  // 4. 历史兼容：只在没有任何明确标识时，才用 iOS17 兜底
  const isIos = /iPhone|iPad|iPod/i.test(userAgent);
  const iosVersion = userAgent.match(/OS (\d+)[._]\d+/i);
  if (isIos && iosVersion && iosVersion[1] === '17') {
    return true;
  }
  return false;
}
/**
 * 根据userAgent判断页面是否在鑫联盟app中
 */
export const isXlm = checkUserAgent(ua);

/**
 * 根据userAgent判断页面是否在mpos app中
 */
export const isMpos = /SuiXingPay-Mpos/i.test(ua);

/**
 * 根据userAgent判断页面是否在结赢 app中
 */
export const isJY = /Suixingpay-(Syt|JY)/i.test(ua);

/**
 * 鑫联盟webview加载完成后自动通知
 */
window.JSBridge.register('rnBridgeInitEnd', () => {
  console.log('rnBridgeInitEnd-------------------------', isReady);
  if (isReady) return;
  isReady = true;
  initCallback && xlmLoginInfo(initCallback);
});

/**
 * 获取盟友登录信息
 * @param {Function} callback 回调函数
 */
export const xlmLoginInfo = callback => {
  window.JSBridge.invoke(
    'loginInfo',
    res => {
      sensorsLogin(res.userId);
      registerPage({
        s_id: res.userId,
        m_id: res.referralCode,
        page_url: window.location.href,
      });
      window.sessionStorage['xlm-token'] = res.token;
      window.sessionStorage['xlm-version'] = res.appVersion;
      window.sessionStorage[XLM_VERSION_ORIGIN_KEY] = res.appVersionOrigin || res.appVersion;
      window.sessionStorage['xlm-userId'] = res.userId;
      window.sessionStorage['xlm-referralCode'] = res.referralCode;
      callback(res);
    },
    {},
  );
};

/**
 * 鑫联盟webview初始化
 * @param {Function} callback 初始化后的回调
 */
export const xlmReady = callback => {
  console.log('xlmReady-------------------------', isReady);
  if (isReady) {
    xlmLoginInfo(callback);
  } else {
    initCallback = callback;
  }
};

/**
 * 鑫联盟App退出登录
 */
export const xlmLotOut = () => {
  window.JSBridge.invoke('logOut', () => {}, {});
};

/**
 * 设置App头部右侧按钮
 * @param {Object} options 参数
 * @param {Object} onClick 点击事件
 */
export const rightButton = (options = {}, onClick = () => {}) => {
  window.JSBridge.invoke(
    'rightButton',
    key => {
      onClick(key);
    },
    options,
  );
};

/**
 * 关闭webview页面并回传数据
 */
export const backWebView = data => {
  window.JSBridge.invoke('back', () => {}, data || {});
};

/**
 * 调用鑫联盟分享
 * @param {Object} options 参数
 * @param {Object} onClick
 */
export const share = (options = {}, onClick = () => {}) => {
  window.JSBridge.invoke(
    'share',
    params => {
      onClick(params);
    },
    options,
  );
};

/**
 * 调用鑫联盟分享,分享给微信好友
 * @param {Object} options 参数
 * @param {Object} onClick
 */
export const shareToSession = (options = {}, onClick = () => {}) => {
  window.JSBridge.invoke(
    'shareToSession',
    key => {
      onClick();
    },
    options,
  );
};

/**
 * 调用鑫联盟分享,分享到朋友圈
 * @param {Object} options 参数
 * @param {Object} onClick
 */
export const shareToTimeline = (options = {}, onClick = () => {}) => {
  window.JSBridge.invoke(
    'shareToTimeline',
    key => {
      onClick();
    },
    options,
  );
};

/**
 * 调用鑫联盟复制字符串
 * @param {Object} data 参数
 * @param {Object} onClick
 */
export const copyString = (data = '', onClick = () => {}) => {
  window.JSBridge.invoke(
    'copyString',
    key => {
      onClick();
    },
    data,
  );
};

/**
 * 调用鑫联盟保存图片
 * @param {String} imageUrl 参数
 * @param {Object} onClick
 */
export const saveImage = (options = {}, onClick = () => {}) => {
  window.JSBridge.invoke(
    'saveImage',
    key => {
      onClick();
    },
    options,
  );
};

/**
 * 跳转到指定页面
 * @param {String} routeName 路由名称
 * @param {Object} params 页面参数
 */
export const navigate = (options = {}, onClick = () => {}, backCallback = false) => {
  const { routeName, params = {} } = options;
  const routeOptions = parseRoute(routeName);
  window.JSBridge.invoke(
    'navigate',
    key => {
      onClick && onClick();
    },
    {
      routeName: routeOptions.routeName,
      params: {
        ...routeOptions.params,
        ...params,
      },
      backCallback,
    },
  );
};

/**
 * 跳转到扫描二维码页面
 * @param {String} routeName 路由名称
 * @param {Object} params 页面参数
 * @param {Function} postMessage
 */
export const scanQrCode = (options = {}, onClick = () => {}) => {
  window.JSBridge.invoke(
    'scanQrCode',
    key => {
      onClick(key);
    },
    options,
    postMessage,
  );
};

/**
 * 跳转到新的webview
 * @param {Object} params 页面参数
 */
export const pushWebView = (options = {}, callback = () => {}) => {
  window.JSBridge.invoke('openWeb', callback, options);
};

/**
 * 获取webview能力配置
 * @param {Function} callback 回调函数
 */
export const getWebViewCapabilities = (callback = () => {}) => {
  window.JSBridge.invoke('webViewCapabilities', callback, {});
};

/**
 * 重置当前连续webview历史并打开新的webview
 * @param {Object} params 页面参数
 */
export const resetWebView = (options = {}, callback = () => {}, fallback = () => {}) => {
  let handled = false;
  const fallbackTimer = window.setTimeout(() => {
    if (handled) return;
    handled = true;
    fallback();
  }, WEBVIEW_CAPABILITY_TIMEOUT);

  const openResetWebView = () => {
    if (handled) return;
    handled = true;
    window.clearTimeout(fallbackTimer);
    window.JSBridge.invoke('openWeb', callback, {
      ...options,
      resetHistory: true,
    });
  };

  const fallbackWebView = () => {
    if (handled) return;
    handled = true;
    window.clearTimeout(fallbackTimer);
    fallback();
  };

  try {
    getWebViewCapabilities(capabilities => {
      if (capabilities && capabilities.resetHistory) {
        openResetWebView();
        return;
      }
      fallbackWebView();
    });
  } catch (error) {
    fallbackWebView();
  }
};

/**
 * 返回到指定url的webview页面
 */
export const popToWebViewUrl = (options = {}, callback = () => {}) => {
  window.JSBridge.invoke('popToWebViewUrl', callback, options);
};

/**
 * 设置webview页面属性
 */
export const setPageSettings = (options = {}) => {
  window.JSBridge.invoke('pageSettings', () => {}, options);
};

/**
 * 获取app定位信息
 * @param {Function} callback 回调函数
 */
export const getLocation = (callback = () => {}) => {
  window.JSBridge.invoke('getLocation', callback, {});
};

/**
 * 修改页面title
 */
export const resetTitle = title => {
  window.JSBridge.invoke('resetTitle', () => {}, { title });
};
/**
 * 焦点
 */
export const onPageFocus = callback => {
  window.JSBridge.invoke('onPageFocus', callback, {});
};

/**
 * 打开相机获取图片
 **/
export const openXlmCamera = (callback = () => {}) => {
  window.JSBridge.invoke(
    'chooseCameraImageBase64',
    res => {
      if (!res?.base64) return;
      let fileBase64 = res.base64;
      if (!res.base64.includes('data:image')) {
        fileBase64 = `data:${res.mime || 'image/jpeg'};base64,${res.base64}`;
      }
      callback(fileBase64);
    },
    {},
  );
};

/**
 * 打开相册获取图片
 **/
export const openXlmAlbum = (callback = () => {}) => {
  window.JSBridge.invoke(
    'chooseAlbumImageBase64',
    res => {
      if (!res?.base64) return;
      let fileBase64 = res.base64;
      if (!res.base64.includes('data:image')) {
        fileBase64 = `data:${res.mime || 'image/jpeg'};base64,${res.base64}`;
      }
      callback(fileBase64);
    },
    {},
  );
};
